import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { Clock, XCircle } from "lucide-react";

export default function QrStatusCard() {
  const { t } = useLang();
  const { refresh } = useAuth();
  const [req, setReq] = useState(null);
  const prev = useRef(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/qr/my-request");
      setReq(data.request);
      if (data.request && prev.current && prev.current !== "approved" && data.request.status === "approved") {
        await refresh();
        toast.success("✅ Your QR payment was verified — everything is unlocked!");
      }
      if (data.request) prev.current = data.request.status;
    } catch { /* ignore */ }
  }, [refresh]);

  useEffect(() => {
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, [load]);

  if (!req || req.status === "approved") return null;

  if (req.status === "rejected") {
    return (
      <div className="rounded-card bg-red-50 border border-red-200 p-4" data-testid="qr-status-card-rejected">
        <div className="flex items-center gap-2 text-red-700 font-bold"><XCircle className="w-5 h-5" /> QR payment not verified</div>
        <p className="text-sm text-red-700/80 mt-1">{req.reason}</p>
        <Link to="/pay-qr" className="btn-3d-green inline-flex mt-3 text-sm" data-testid="qr-resubmit-btn">{t("qr_resubmit")}</Link>
      </div>
    );
  }

  return (
    <Link to="/pay-qr" className="block rounded-card bg-thali-turmeric/20 border border-thali-turmeric/40 p-4" data-testid="qr-status-card">
      <div className="flex items-center gap-2 font-bold text-thali-ink"><Clock className="w-5 h-5 text-thali-saffron" /> ⏳ {t("qr_pending_status")}</div>
      <div className="text-sm text-thali-ink/70 mt-1">{t("qr_request_id")}: <b>{req.request_code}</b> · UTR: <b>{req.utr}</b></div>
    </Link>
  );
}
